import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Stepper,
  Step,
  StepLabel,
  Typography,
  Card,
  CardContent,
  Stack,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  Paper,
  MenuItem,
  useMediaQuery, useTheme 
} from "@mui/material";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import {api} from "../Login/axiosConfig"; // ✅ use your configured axios instance
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";
import Header1 from "../Header/Header1";
import Footer2 from "../Footer/Footer2";
import { useAuth } from '../../AuthContext';
import { useNavigate, useLocation } from "react-router-dom";
import Platform from "../Platform/Platform";
// import zIndex from "@mui/material/styles/zIndex";

const steps = [
  "Ask",
  "Select Date",
  "Select Time",
  "Select Duration",
  "Select Language",
  "Select Price"
];
const API_URL = process.env.REACT_APP_API_URL;

export default function AskExpert() {
  const [activeStep, setActiveStep] = useState(0);
  const [description, setDescription] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [duration, setDuration] = useState("");
  const [price, setPrice] = useState("");
  const [languages, setLanguages] = useState([]);
const [selectedLanguage, setSelectedLanguage] = useState("");

  const { userId } = useAuth();
    const { role, roles } = useAuth();
  const userRoles = Array.isArray(roles) && roles.length > 0 ? roles : [role];

  const allowedRoles = ['anthra-sales-executive', 'admin', 'expert'];

  const { loggedIn } = useAuth();

  const [file, setFile] = useState(null);
  const [previewURL, setPreviewURL] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  // Switch to vertical stepper on small screens
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
  const loadLanguages = async () => {
    try {
      const res = await api.get(`${API_URL}/api/languages/`);

      // Store only names, not full objects
      setLanguages(res.data.map(lang => lang.name));

    } catch (error) {
      console.error("Error loading languages:", error);
    }
  };
  loadLanguages();
}, []);


  useEffect(() => {
    return () => {
      if (previewURL) URL.revokeObjectURL(previewURL);
    };
  }, [previewURL]);

  const updatePreviewURL = (file) => {
    if (!file) return;
    const url = URL.createObjectURL(file);
    setPreviewURL(url);
  };

  

  // const handleFileChange = (e) => {
  //   const selectedFile = e.target.files[0];
  //   if (!selectedFile) return;
  //   setFile(selectedFile);
  //   updatePreviewURL(selectedFile);
  // };

  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

const handleFileChange = (e) => {
  const selectedFile = e.target.files[0];
  if (!selectedFile) return;

  if (selectedFile.size > MAX_FILE_SIZE) {
    alert("File size must be less than 5 MB");
    e.target.value = ""; // reset file input
    return;
  }

  setFile(selectedFile);
  updatePreviewURL(selectedFile);
};


  const removeMedia = () => {
    setFile(null);
    setPreviewURL(null);
  };

  const renderMediaPreview = () => {
    if (!file || !previewURL) return null;

    const type = file.type;
    if (type.startsWith("image/")) {
      return <img src={previewURL} alt="preview" style={{ width: "100%", borderRadius: 8 }} />;
    } else if (type.startsWith("video/")) {
      return <video controls src={previewURL} style={{ width: "100%", borderRadius: 8 }} />;
    } else if (type.startsWith("audio/")) {
      return <audio controls src={previewURL} style={{ width: "100%" }} />;
    } else if (
      type === "application/pdf" ||
      type.includes("word") ||
      type.includes("excel") ||
      type.includes("text")
    ) {
      return (
        <Typography variant="subtitle1" sx={{ mt: 1 }}>
          {file.name}
        </Typography>
      );
    } else {
      return <Typography>Cannot preview this file type</Typography>;
    }
  };

  const uploadToS3 = async () => {
    if (!file) return null;

    

    const formData = new FormData();
    formData.append("file", file);

    const uploadRes = await api.post(`${API_URL}/api/upload-s3/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return uploadRes.data.key;
  };

  const handleSubmit = async () => {
    try {
      
      // const mediaKey = await uploadToS3();
      const mediaKey = file ? await uploadToS3() : null;

      const payload = {
  user_id: userId ? userId : null, // must be valid UUID string or null
  description: description || null,
  selectedDate: selectedDate ? selectedDate.format("YYYY-MM-DD") : null,
  startTime: startTime ? startTime.format("HH:mm:ss") : null,
  duration: duration ? parseFloat(duration) : null,
  price: price ? parseFloat(price) : null,
  language: selectedLanguage || null,
  media_key: mediaKey || null,
};



      console.log("Payload:", payload);

      const res = await api.post(`${API_URL}/api/requests/`, payload);
      console.log("Response:", res.data);

      setOpenDialog(false);
      setFile(null);
      setPreviewURL(null);
      setDescription("");
      setSelectedDate(null);
      setStartTime(null);
      setDuration("");
      setPrice("");
      setSelectedLanguage("");

      alert("Request submitted successfully!");
    } catch (error) {
      console.error("Error submitting request:", error);
      alert("Failed to submit request. Check console.");
    }
  };

  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <Stack spacing={3}>
            <TextField
              label="Ask"
              multiline
              rows={4}
              variant="filled"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              fullWidth
            />

            {/* <Button variant="contained" component="label" startIcon={<UploadFileIcon />} disabled={!!file}>
              Upload Media
              <input type="file" hidden onChange={handleFileChange} />
            </Button> */}

            <Button
  variant="contained"
  component="label"
  startIcon={<UploadFileIcon />}
  disabled={!!file}
>
  Upload Media (Max 5 MB)
  <input
    type="file"
    hidden
    onChange={handleFileChange}
  />
</Button>



            {file && (
              <Stack direction="row" mt={1}>
                <Button color="error" variant="outlined" onClick={removeMedia} startIcon={<DeleteIcon />}>
                  Remove
                </Button>
              </Stack>
            )}

            <Box mt={2}>{renderMediaPreview()}</Box>
          </Stack>
        );

      case 1:
        return <DatePicker label="Select Date" value={selectedDate} onChange={setSelectedDate} />;

      case 2:
        return <TimePicker label="Select Time" value={startTime} onChange={setStartTime} />;

      case 3:
        return (
          <TextField
            label="Duration (minutes)"
            type="number"
            value={duration}
            onChange={(e) => setDuration(e.target.value)}
            fullWidth
          />
        );

      case 4:
        return (
          <TextField
            select
            label="Select Language"
            value={selectedLanguage}
            onChange={(e) => setSelectedLanguage(e.target.value)}
            fullWidth
          >
            {languages.map((name, index) => (
              <MenuItem key={index} value={name}>
                {name}
              </MenuItem>
            ))}
          </TextField>
        );

      case 5:
        return (
          <TextField
            label="Price"
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            fullWidth
          />
        );

      default:
        return "Unknown Step";
    }
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div>
      <Box
              sx={{
                position: 'fixed', // or 'relative' / 'sticky' based on your layout
                top: 0,
                left: 0,
                width: '100%',
                zIndex: 1300, // higher than MUI drawers (default is 1200)
              }}
            >
       
                {/* // <Header1 style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', alignItems: 'center' }} /> */}
                <Header1/>
            </Box>
      <Platform />

      {loggedIn && (
            <Box position="static" color="primary" sx={{ mt: 7, backgroundColor: '#000000' }}>
              <Toolbar>
                <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', gap: 2 }}>
                  
                  {/* Single Button */}
                  <Button
                    variant={isActive('/ask-expert') ? 'contained' : 'outlined'}
                    color={isActive('/ask-expert') ? 'secondary' : 'inherit'}
                    onClick={() => navigate('/ask-expert')}
                    sx={{
                      borderRadius: '20px',
                      textTransform: 'none',
                      fontWeight: 'bold',
                      px: 3,
                      py: 1,
                      bgcolor: isActive('/ask-expert') ? 'secondary.main' : 'transparent',
                      color: isActive('/ask-expert') ? 'white' : 'inherit',
                      border: '2px solid',
                      borderColor: isActive('/ask-expert') ? 'primary.main' : 'inherit',
                      '&:hover': {
                        bgcolor: isActive('/ask-expert') ? 'secondary.dark' : 'action.hover',
                        borderColor: 'primary.main',
                      },
                    }}
                  >
                    Ask
                  </Button>
            
                  {/* Multiple Button */}
                  {/* {allowedRoles.some(r => userRoles.includes(r)) && ( */}
                  <Button
                    variant={isActive('/my-requests-list') ? 'contained' : 'outlined'}
                    color={isActive('/my-requests-list') ? 'secondary' : 'inherit'}
                    onClick={() => navigate('/my-requests-list')}
                    sx={{
                      borderRadius: '20px',
                      textTransform: 'none',
                      fontWeight: 'bold',
                      px: 3,
                      py: 1,
                      bgcolor: isActive('/my-requests-list') ? 'secondary.main' : 'transparent',
                      color: isActive('/my-requests-list') ? 'white' : 'inherit',
                      border: '2px solid',
                      borderColor: isActive('/my-requests-list') ? 'primary.main' : 'inherit',
                      '&:hover': {
                        bgcolor: isActive('/my-requests-list') ? 'secondary.dark' : 'action.hover',
                        borderColor: 'primary.main',
                      },
                    }}
                  >
                    Manage
                  </Button>
                  {/* // )} */}
                  {allowedRoles.some(r => userRoles.includes(r)) && (
                  <Button
                    variant={isActive('/my-requests-list-expert') ? 'contained' : 'outlined'}
                    color={isActive('/my-requests-list-expert') ? 'secondary' : 'inherit'}
                    onClick={() => navigate('/my-requests-list-expert')}
                    sx={{
                      borderRadius: '20px',
                      textTransform: 'none',
                      fontWeight: 'bold',
                      px: 3,
                      py: 1,
                      bgcolor: isActive('/my-requests-list-expert') ? 'secondary.main' : 'transparent',
                      color: isActive('/my-requests-list-expert') ? 'white' : 'inherit',
                      border: '2px solid',
                      borderColor: isActive('/my-requests-list-expert') ? 'primary.main' : 'inherit',
                      '&:hover': {
                        bgcolor: isActive('/my-requests-list-expert') ? 'secondary.dark' : 'action.hover',
                        borderColor: 'primary.main',
                      },
                    }}
                  >
                    Expert Mode
                  </Button>
                  )}
            
                </Box>
              </Toolbar>
            </Box>
            )}
      <Card sx={{ maxWidth: 900, margin: "auto", mt: 5, p: 5, borderRadius: 5, background: "rgba(0,0,0,0.15)", backdropFilter: "blur(15px)" }}>
        <CardContent>
          <Typography variant="h3" mb={4} textAlign="center" sx={{ fontWeight: 800, background: "linear-gradient(135deg,#ff6a00,#ee0979)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
            Ask an Expert
          </Typography>

          <Stepper
      activeStep={activeStep}
      alternativeLabel={!isSmallScreen}
      orientation={isSmallScreen ? "vertical" : "horizontal"}
      sx={{
        width: "100%",
        "& .MuiStepLabel-label": {
          wordBreak: "break-word", // prevent text overflow
        },
      }}
    >
      {steps.map((label, index) => (
        <Step key={label} onClick={() => setActiveStep(index)} sx={{ cursor: "pointer" }}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>

          <Divider sx={{ my: 3 }} />

          <Box mt={2}>{renderStepContent()}</Box>

          <Stack direction="row" spacing={2} mt={5} justifyContent="space-between">
            {activeStep > 0 && <Button variant="outlined" onClick={() => setActiveStep((s) => s - 1)}>Back</Button>}

            <Stack direction="row" spacing={2}>
              {activeStep < steps.length - 1 ? (
                <Button variant="contained" onClick={() => setActiveStep((s) => s + 1)}>Next</Button>
              ) : (
                <Button variant="contained" color="success" onClick={() => setOpenDialog(true)}>Submit</Button>
              )}
            </Stack>
          </Stack>

          <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="sm">
            <DialogTitle>Confirm Your Request</DialogTitle>
            <DialogContent>
              <List>
                <ListItem>
                  <ListItemText primary="Description" secondary={description || "Not provided"} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Selected Date" secondary={selectedDate ? selectedDate.format("YYYY-MM-DD") : "Not provided"} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Start Time" secondary={startTime ? startTime.format("HH:mm") : "Not provided"} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Duration" secondary={duration || "Not provided"} />
                </ListItem>
                 <ListItem>
                  <ListItemText primary="Language" secondary={selectedLanguage} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Price" secondary={price || "Not provided"} />
                </ListItem>
                {file && <ListItem>{renderMediaPreview()}</ListItem>}
              </List>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
              <Button variant="contained" color="success" onClick={handleSubmit}>Confirm & Submit</Button>
            </DialogActions>
          </Dialog>
        </CardContent>
      </Card>
      <Footer2 />
    </div>
  );
}
